import React, { useCallback, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Checkbox, Form, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

const MenuShowStandaloneFilter = ({ queryParamName, disabled }) => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const showStandaloneMenus = getQueryParams(search)[queryParamName] === true

  const handleChange = useCallback(
    event => {
      const isChecked = event.target.checked

      history.push(
        createUrl(pathname, search, {
          [queryParamName]: isChecked ? 'true' : undefined,
        }),
      )
    },
    [history, pathname, search, queryParamName],
  )

  useEffect(() => {
    if (disabled) {
      const newUrl = createUrl(pathname, search, {
        [queryParamName]: undefined,
      })
      history.push(newUrl)
    }
  }, [disabled, history, pathname, search, queryParamName])

  const checkboxElement = (
    <Checkbox
      checked={!disabled && showStandaloneMenus}
      onChange={handleChange}
      disabled={disabled}
    />
  )

  return (
    <Form.Item label="Show standalone menus">
      {disabled ? (
        <Tooltip title="This is available only when Menu ID is empty.">
          {checkboxElement}
        </Tooltip>
      ) : (
        checkboxElement
      )}
    </Form.Item>
  )
}

MenuShowStandaloneFilter.propTypes = {
  queryParamName: PropTypes.string,
  disabled: PropTypes.bool,
}

MenuShowStandaloneFilter.defaultProps = {
  queryParamName: 'showStandaloneMenus',
  disabled: true,
}

export default MenuShowStandaloneFilter
